export enum InvestigationMinutesResponseStatus {
	AnsweredInWriting = "ANSWERED_IN_WRITING",
	NoAnswerInPeriod = "NO_ANSWER_IN_PERIOD",
	AwaitingAnswer = "AWAITING_ANSWER",
	RespondentRequest = "RESPONDENT_REQUEST",
	Attended = "ATTENDED",
	Absent = "ABSENT",
	AwaitingSession = "AWAITING_SESSION",
	NotHeld = "NOT_HELD",
	Cancelled = "CANCELLED",
}
